import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { DispatchTaskModalComponent, DispatchTaskModalComponentInput } from './dispatch-task-modal/dispatch-task-modal.component';

@Component({
  selector: 'app-settings-scripts',
  templateUrl: './settings-scripts.component.html',
  // styleUrls: ['./settings-scripts.component.css']
})
export class SettingsScriptsComponent implements OnInit {
  constructor(private route: ActivatedRoute, private titleService: Title, private _router: Router, public dialog: MatDialog) { }

  ngOnInit() {
  }

  //api
  runSendLeadsService() {
    this.openDispatchTaskModal(
      'Would you like to run the send leads service?',
      `${environment.services_tdusa_admin}/v1/scripts/send-leads`
    );
  }

  runNightlyAuditService() {
    this.openDispatchTaskModal(
      'Would you like to run the nightly audit service?',
      `${environment.services_tdusa_admin}/v1/scripts/nightly-audit`
    );
  }

  runSetSpendService() {
    this.openDispatchTaskModal(
      'Would you like to run the set spend service?',
      `${environment.services_tdusa_admin}/v1/scripts/set-spend`
    );
  }

  runParseXmlFeedService() {
    this.openDispatchTaskModal(
      'Would you like to run the parse XML feeds service?',
      `${environment.services_tdusa_admin}/v1/scripts/parse-feeds`
    );
  }

  runParseTenstreetJobsService() {
    this.openDispatchTaskModal(
      'Would you like to run the Tenstreet jobs service?',
      `${environment.services_tdusa_admin}/v1/scripts/parse-job-boards`
    );
  }

  runAcquireCsvService() {
    this.openDispatchTaskModal(
      'Would you like to run the Acquire CSV service?',
      `${environment.services_tdusa_admin}/v1/scripts/acquire-csv`
    );
  }

  runSendOpsEmailsService() {
    this.openDispatchTaskModal(
      'Would you like to run the send ops emails service?',
      `${environment.services_tdusa_admin}/v1/scripts/ops-emails`
    );
  }

  openDispatchTaskModal(title: string, endpoint: string) {
    const input: DispatchTaskModalComponentInput = {
      title,
      confirmButtonText: 'Run Service',
      icon: 'info',
      showCancelButton: true,
      endpoint
    };

    this.dialog.open(DispatchTaskModalComponent, {
      data: input,
    });
  }
}
